import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ApError } from './error';

/**
 * @ngdoc service
 * @name ApErrorService
 * @module ApErrorModule
 *
 * @description
 * Service that exposes any error thrown in a reactive fashion.
 **/
@Injectable()
export class ApErrorService {
    private readonly errorSubject: Subject<ApError> = new Subject();

    /**
     * **Do not call this method** It should only be used by `ApErrorHandlerService`
     *
     * Publish an error.
     *
     * @param error
     */
    public publish(error: ApError): void {
        this.errorSubject.next(error);
    }

    /**
     * @returns stream of all errors.
     */
    public error$(context?: string): Observable<ApError> {
        return this.errorSubject.pipe(filter((error: ApError) => context === undefined || context === error.context));
    }
}
